export default __webpack_public_path__ + "static/media/MANSIK.1e757515.jpg";